import { RequestService } from '../request';

import { IDemoDayRankingEntry } from './demo-day.contract';

export class DemoDayService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getRanking() {
    return this.fetcher<IDemoDayRankingEntry[]>('/demo-day/ranking');
  }
}
